import { BrandEnum, DinoJackpotOptInStatus } from '@/globalTypes';
import { Nullable } from '@/types';

const statusLabels: Record<DinoJackpotOptInStatus, string> = {
  [DinoJackpotOptInStatus.optedIn]: 'Opted in',
  [DinoJackpotOptInStatus.optedOut]: 'Opted out',
  [DinoJackpotOptInStatus.undefined]: 'Not asked / no record',
};

export const optInStatusLabel = (status?: DinoJackpotOptInStatus) =>
  status ? statusLabels[status] : '-';

// bo-gateway role middleware message (AuthorizationFailure)
export const isAccessDeniedError = (error?: {
  graphQLErrors?: { message: string }[];
}) =>
  Boolean(error?.graphQLErrors?.some((e) => /not authorized/i.test(e.message)));

// RangeDate needs both bounds; open sides use fixed dates (not "now") so the
// variables stay stable across renders and urql does not refetch in a loop
const OPEN_START = new Date(0);
const OPEN_END = new Date('9999-12-31T23:59:59.999Z');

export const processedAtRange = (from: Nullable<Date>, to: Nullable<Date>) =>
  from || to
    ? {
        from: (from ?? OPEN_START).toJSON(),
        to: (to ?? OPEN_END).toJSON(),
      }
    : undefined;

export const buildHistoryVariables = ({
  playerId,
  brand,
  query: { sourceCode, from, to, ...rest },
}: {
  playerId: string;
  brand: BrandEnum;
  query: {
    sourceCode?: Nullable<string>;
    optedIn?: Nullable<boolean>;
    from?: Nullable<Date>;
    to?: Nullable<Date>;
    desc?: Nullable<boolean>;
    after?: Nullable<string>;
    before?: Nullable<string>;
    first?: Nullable<number>;
  };
}) => {
  const variables = {
    playerId,
    brand,
    processedAt: processedAtRange(from, to),
    ...rest,
  };
  return sourceCode
    ? { bySourceCode: true, variables: { ...variables, sourceCode } }
    : { bySourceCode: false, variables };
};
